document.addEventListener('DOMContentLoaded', function () {
  const videoSections = document.querySelectorAll(
    '.hero-video-slider .video-section',
  );

  videoSections.forEach((videoSection) => {
    const video = videoSection.querySelector('video');
    const button = videoSection.querySelector('.video_play_pause');
    const nextMuteUnmuteButton = videoSection.querySelector('.video_mute_unmute');
    const youtubeIframe = videoSection.querySelector(
      '.hero-video-slider-youtube-video',
    );

    if (!video) return;
    if(video.classList.contains("section-hero-video-mp")){
        const mobileVideoUrl = video.closest('.video-section').getAttribute('data-video-mobile');
        const desktopVideoUrl = video.closest('.video-section').getAttribute('data-video-desktop');
        const videoTag = video.querySelector("source");
        if(mobileVideoUrl != "" && mobileVideoUrl != null){
          // Function to set the video source based on the screen width
          const setVideoSource = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth > 744) {
              videoTag.setAttribute('src', desktopVideoUrl);
            } else {
              videoTag.setAttribute('src', mobileVideoUrl);
            }
            const videoElement = videoTag.closest('video');
            if (videoElement) {
              videoElement.load(); // Reload the video to apply the new source
            }
          };
          
          // Set initial video source
          setVideoSource();
          window.addEventListener('resize', debounce(setVideoSource, 200));
        }
        function debounce(func, wait) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }
      }
    
    function videoTagPlayPause(video, button) {
      if (video.paused) {
        video.play();
        button.classList.remove('video_play_pause--paused');
        button.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        button.classList.add('video_play_pause--paused');
        button.setAttribute('aria-label', 'Play video');
      }
    }

    function videoTagMuteUnmute(video, button) {
      video.muted = !video.muted;
      button.classList.toggle('video_muted', video.muted);
      button.classList.toggle('video_unmuted', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    //if only one slide
    var numberOfVideos = videoSection
      .closest('.slideshow')
      .getAttribute('data-videos');

    if (numberOfVideos == 1) {
      if (video && button) {
        videoTagPlayPause(video, button);
      }
    }

    if (video) {
      if (button) {
        button.addEventListener('click', () => {
          videoTagPlayPause(video, button);
        });
      }
      
      if (nextMuteUnmuteButton) {
        nextMuteUnmuteButton.addEventListener('click', () => {
          videoTagMuteUnmute(video, nextMuteUnmuteButton);
        });
      }
      
    }

    // Load the YouTube IFrame API for YouTube videos
    if (youtubeIframe) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Initialize YouTube Player once the API is ready
      window.onYouTubeIframeAPIReady = function () {
        new YT.Player(youtubeIframe.id, {
          events: {
            onReady: function (event) {
              if (button) {
                button.setAttribute('aria-label', 'Play video');
              }

              function YTPlayPause(YT, button) {
                const playerState = event.target.getPlayerState();
                console.log(playerState);
                console.log(YT.PlayerState);
                // If the video is paused or in the cued state, play it
                if (
                  playerState === YT.PlayerState.PAUSED ||
                  playerState === YT.PlayerState.CUED
                ) {
                  event.target.playVideo();
                  if (button) {
                    button.classList.remove('video_play_pause--paused');
                    button.setAttribute('aria-label', 'Pause video');
                  }
                }
                // If the video has ended, reset to start and play it
                else if (playerState === YT.PlayerState.ENDED) {
                  event.target.seekTo(0);
                  event.target.playVideo();
                  if (button) {
                    button.classList.remove('video_play_pause--paused');
                    button.setAttribute('aria-label', 'Pause video');
                  }
                }
                // If the video is playing, pause it
                else {
                  event.target.pauseVideo();
                  if (button) {
                    button.classList.add('video_play_pause--paused');
                    button.setAttribute('aria-label', 'Play video');
                  }
                }
              }
              if (button) {
                if (numberOfVideos == 1) {
                  YTPlayPause(YT, button);
                }
                button.addEventListener('click', () => {
                  YTPlayPause(YT, button);
                });
              }
              
            },

            onStateChange: function (event) {
              const playerState = event.data;
              // Handle the button state based on the player state
              if (playerState === YT.PlayerState.ENDED) {
                event.target.seekTo(0);
                event.target.playVideo();
                if (button) {
                  button.classList.remove('video_play_pause--paused');
                  button.setAttribute('aria-label', 'Pause video');
                }
              } else if (playerState === YT.PlayerState.PAUSED) {
                if (button) {
                  button.classList.add('video_play_pause--paused');
                  button.setAttribute('aria-label', 'Play video');
                }
              } else if (playerState === YT.PlayerState.PLAYING) {
                if (button) {
                  button.classList.remove('video_play_pause--paused');
                  button.setAttribute('aria-label', 'Pause video');
                }
              }
            },
          },
        });
      };
    }
  });
});
